import React, { Fragment, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faUserPlus,
    faPenSquare,
    faWindowClose,
    faEdit,
    faTrashAlt,
    faPlusSquare,
    faGreaterThan,
    faKaaba,
    faBoxes
} from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import { useHistory, useParams } from 'react-router';
import { useSelector } from 'react-redux';

import { IValue } from 'component/form/input-clubs/types';
import { useCancelTokens } from 'component/core/cancel-token';
import { ISelectedMap } from 'route/dashboard/photos/types';
import { Redirect } from 'react-router-dom';
import { IStore } from 'store/reducers/types/reducers';
import { key as keyDeviceInfo } from 'store/reducers/deviceInfo/reducer';
import { key as keyUser } from 'store/reducers/user/reducer';
import UI from 'component/ui';
import Button from 'component/button';
import { useRegistry } from 'component/form';
import { useClassnames } from 'hook/use-classnames';
import { useTranslation } from 'react-i18next';
import debounce from 'lodash.debounce';
import AlbumModal from 'component/modal/album';
import AlbumAccess from 'component/modal/album-access';
import SideAction from 'component/wireframes/side-action';
import ButtonCircular from 'component/button/circular';
import ActionButton from 'component/button/circular/action-button';
import { useAlert } from 'component/alert/provider';
import {
    DataFilesTmpFacesItem,
    DataFilesTmpFacesPersonsItem
} from 'component/api/types/api/tmp-file/get-files-list/get/code-200';

import style from './index.pcss';
import { IPayload } from 'component/form/types';
import Loader from 'component/loader';
import PhotoSaleModal from 'component/modal/sale';
import CustomAlert from 'component/custom-alert';
import api from 'src/api';
import { AlbumItem, AlbumListItem, AlbumPhoto, GetAlbumAlbumsListData, GetAlbumPhotoData } from 'src/api/albums/types';
import { Page } from 'src/api/base';
import newSortPhotosList, { ISortedMap } from 'component/helper/new-sort-photos-list';
import NewPhotoList from 'component/photo-list/new-photo-list';
import { parse, stringify } from 'query-string';
import { INormalizeObject } from 'component/helper/types/normalize-object';
import { normalizeObject } from 'component/helper/normalize-object';
import { BulkUpdatePhotoData } from 'src/api/photos/types';
import AlbumCard from 'component/album';
import Breadcrumbs from 'component/breadcrumbs';

const PHOTOS_LIMIT = 25;
const ALBUMS_LIMIT = 10;

const getNormalizedQuery = () => {
    return normalizeObject(parse(location.search));
};
const Album = () => {
    const cn = useClassnames(style);
    const { t } = useTranslation();
    const { field, form } = useRegistry();
    const { id }: { id: string } = useParams();
    const history = useHistory();
    const { show, hide } = useAlert();

    const userId = useSelector<IStore, number | undefined>((store) => store[keyUser].id);
    const isMobile = useSelector<IStore, boolean>((state) => state[keyDeviceInfo].mobile);
    const isTablet = useSelector<IStore, boolean>((state) => state[keyDeviceInfo].tablet);
    const [ queryParams, setQueryParams] = useState<INormalizeObject>(getNormalizedQuery());

    const [photoWithFaceMap, setPhotoWithFaceMap] = useState<ISortedMap | null>(null);
    const [photoWithoutFaceMap, setPhotoWithoutFaceMap] = useState<ISortedMap | null>(null);
    const [showWarningModal, setShowWarningModal] = useState<{type?: string, text?: string, show: boolean} | null>();

    const [isAlbumInfoPending, setIsAlbumInfoPending] = useState<boolean>(false);
    const [isLoadingParentInfo, setIsLoadingParentInfo] = useState<boolean>(false);

    const [idsWithFaces, setIdsWithFaces] = useState<ISelectedMap>({});
    const [idsWithoutFaces, setIdsWithoutFaces] = useState<ISelectedMap>({});
    const refIdsWithFaces = useRef<ISelectedMap>(idsWithFaces);
    const refIdsWithoutFaces = useRef<ISelectedMap>(idsWithoutFaces);
    const [isModerationBtn, setIsModerationBtn] = useState<boolean>(false);
    const [idsList, setIdsList] = useState<Array<number>>([]);

    const [token, tokenWithFace, tokenWithoutFace, tokenAlbum, tokenEdit] = useCancelTokens(5);
    const [albumInfo, setAlbumInfo] = useState<AlbumItem | null>(null);
    const [parentInfo, setParentInfo] = useState<AlbumItem | null>();
    const [resetIdsList, setResetIdsList] = useState<boolean>(false);
    const refReset = useRef<boolean>(resetIdsList);

    const registry = useRegistry();
    const [cancelToken, tokenEditUser, tokenUserSelfInfo] = useCancelTokens(3);
    const [pending, setPending] = useState<boolean>(false);
    const [message, setMessage] = useState<string | null>(null);
    const [modalForm, setModalForm] = useState<boolean>(false);
    const [modalMessage, setModalMessage] = useState<boolean>(false);
    const [modalAccess, setModalAccess] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);
    const [photoSaleModal, setPhotoSaleModal] = useState<boolean>(false);

    const [photosWithFaceList, setPhotosWithFaceList] = useState<Array<AlbumPhoto>>([]);
    const [photosWithFaceTotal, setPhotosWithFaceTotal] = useState<number>(0);
    const [photosWithFacePage, setPhotosWithFacePage] = useState<number>(1);
    const [isPhotosWithFaceNext, setIsPhotosWithFaceNext] = useState<boolean>(true);
    const [isPhotosWithFaceLoading, setIsPhotosWithFaceLoading] = useState<boolean>(false);
    const [isPhotosWithFaceLoadMore, setIsPhotosWithFaceLoadMore] = useState<boolean>(false);

    const [photosWithoutFaceList, setPhotosWithoutFaceList] = useState<Array<AlbumPhoto>>([]);
    const [photosWithoutFaceTotal, setPhotosWithoutFaceTotal] = useState<number>(0);
    const [photosWithoutFacePage, setPhotosWithoutFacePage] = useState<number>(1);
    const [isPhotosWithoutFaceNext, setIsPhotosWithoutFaceNext] = useState<boolean>(true);
    const [isPhotosWithoutFaceLoading, setIsPhotosWithoutFaceLoading] = useState<boolean>(false);
    const [isPhotosWithoutFaceLoadMore, setIsPhotosWithoutFaceLoadMore] = useState<boolean>(false);

    // sub album
    const [isAlbumListPending, setIsAlbumListPending] = useState<boolean>(false);
    const [isAlbumListLoadMore, setIsAlbumListLoadMore] = useState<boolean>(false);
    const [isAlbumListNext, setIsAlbumListNext] = useState<boolean>(true);
    const [albumListPage, setAlbumListPage] = useState<number>(1);
    const [albumListTotal, setAlbumListTotal] = useState<number>(0);
    const [albumList, setAlbumList] = useState<Array<AlbumListItem>>([]);
    const [isCreateInnerModal, setIsCreateInnerModal] = useState<boolean>(false);
    const [parentAlbum, setParentAlbum] = useState<number | null>(null);

    useEffect(() => {
        setQueryParams(getNormalizedQuery());
    }, [location.search]);

    if(!userId) {
        return <Redirect to="/login" />;
    }

    useEffect(() => {
        if (!queryParams.parent) {
            setParentInfo(null);
        } else {
            setIsLoadingParentInfo(true);
        }
    }, [queryParams]);

    useEffect(() => {
        if (isAlbumListPending || isAlbumListLoadMore) {
            const page: Page = {
                pageNumber: albumListPage,
                pageSize: ALBUMS_LIMIT
            };

            api.albums.getAlbumAlbumsList(Number(id), page)
                .then((resp) => {
                    setAlbumListTotal(resp.data.count);
                    setAlbumList(isAlbumListLoadMore ?
                        [...albumList, ...resp.data.results] : resp.data.results);
                    setIsAlbumListPending(false);
                    setIsAlbumListLoadMore(false);
                    setIsAlbumListNext(!!resp.data.next);
                })
                .catch(() => {
                    setIsAlbumListPending(false);
                    setIsAlbumListLoadMore(false);
                    setIsAlbumListNext(false);
                });
        }
    }, [isAlbumListPending, isAlbumListLoadMore]);

    useEffect(() => {
        if (isAlbumInfoPending) {
            if (queryParams.parent) {
                api.albums.getAlbumAlbumsRetrieve(queryParams.parent, Number(id))
                    .then((resp) => {
                        setAlbumInfo(resp.data);
                        setIsAlbumInfoPending(false);
                    })
                    .catch(() => {
                        setIsAlbumInfoPending(false);
                        history.push('/404');
                    });
            } else {
                api.albums.getAlbumRetrieve(Number(id))
                    .then((resp) => {
                        setAlbumInfo(resp.data);
                        setIsAlbumInfoPending(false);
                    })
                    .catch(() => {
                        setIsAlbumInfoPending(false);
                        history.push('/404');
                    });
            }
        }
    }, [isAlbumInfoPending]);

    useEffect(() => {
        if (isLoadingParentInfo && albumInfo) {
            api.albums.getAlbumRetrieve(queryParams.parent)
                .then((payload) => {
                    setParentInfo(payload.data);
                    setIsLoadingParentInfo(false);
                })
                .catch(() => {
                    setIsLoadingParentInfo(false);
                });
        }
    }, [isLoadingParentInfo, albumInfo]);

    const updPhotoInfo = useCallback((photo_data) => {
        const data: BulkUpdatePhotoData = {
            photos: idsList,
            ...(photo_data.album_id && { album: photo_data.album_id }),
            ...(photo_data.event_id && { event: photo_data.event_id }),
            ...(photo_data.price && { price: photo_data.price }),
            ...(photo_data.price === 0 && { price: null })
        };

        api.photos.bulkUpdatePhoto(data)
            .then(() => {
                if ('album_id' in photo_data || 'is_deleted' in photo_data) {
                    setResetIdsList(true);
                    setIdsList([]);
                }

                setPhotosWithFacePage(1);
                setIsPhotosWithFaceNext(true);
                setIsPhotosWithFaceLoading(true);

                setPhotosWithoutFacePage(1);
                setIsPhotosWithoutFaceNext(true);
                setIsPhotosWithoutFaceLoading(true);

                onShowAlert('success', 'Ваши изменения успешно применены.');
            })
            .catch((err) => {
                if(!axios.isCancel(err)) {
                    onShowAlert('warning', 'Не удалось применить Ваши изменения.');
                }
            });
    }, [idsList]);

    const deletePhotoInfo = useCallback(() => {
        api.photos.bulkDeletePhoto(idsList)
            .then(() => {
                setResetIdsList(true);
                setIdsList([]);

                setPhotosWithFacePage(1);
                setIsPhotosWithFaceNext(true);
                setIsPhotosWithFaceLoading(true);

                setPhotosWithoutFacePage(1);
                setIsPhotosWithoutFaceNext(true);
                setIsPhotosWithoutFaceLoading(true);

                onShowAlert('success', 'Ваши изменения успешно применены.');
            })
            .catch((err) => {
                if (err.response.data[0]) {
                    onShowAlert('warning', err.response.data[0]);
                } else {
                    onShowAlert('warning', 'Не удалось применить Ваши изменения.');
                }
            });
    }, [idsList]);

    const onSubmit = useCallback((is_inner?: boolean) => {
        setPending(true);
        const fields = registry.form.getFields();

        if (fields) {
            const fieldName = fields.get('album_name');
            const fieldDescription = fields.get('album_description');
            const fieldPrivate = fields.get('album_private');
            const fieldPrepaid = fields.get('album_prepaid');
            const fieldVideo = fields.get('album_video');

            if (fieldName && fieldDescription) {

                if (fieldName.value === t('global.reserved-names.my-photo')) {
                    setError(t('global.massage.reserved-name'));
                    setPending(false);
                } else {
                    const updateData = {
                        ...(is_inner && { parent: Number(id) }),
                        name: String(fieldName.value),
                        ...(fieldDescription.value.length && { description: fieldDescription.value}),
                        is_private: fieldPrivate?.value,
                        is_prepaid: fieldPrepaid?.value,
                        is_video: fieldVideo?.value
                    };
                    if (is_inner) {
                        api.albums.createAlbumAlbumsItem(Number(id), updateData)
                        .then((resp) => {
                            setMessage(t('route.album.modal.message-ok'));
                            setIsCreateInnerModal(false);
                            setPending(false);
                            onShowAlert('success', 'Альбом успешно создан.');
                            setAlbumListPage(1);
                            setIsAlbumListNext(true);
                            setIsAlbumListPending(true);
                        })
                        .catch((err) => {
                            if(!axios.isCancel(err)) {
                                setPending(false);
                                if (err.response.status === 404) {
                                    onShowAlert('warning', `${Object.values(err.response.data)[0]}`, true);
                                } else if (Object.values(err.response.data)[0]) {
                                    onShowAlert('warning', `${Object.values(err.response.data)[0]}`);
                                } else {
                                    onShowAlert('warning', 'Что-то пошло не так.');
                                }
                            }
                        });

                    } else if (queryParams.parent) {
                        api.albums.partialUpdateAlbumAlbums(queryParams.parent, Number(id), updateData)
                            .then((resp) => {
                                setMessage(t('route.album.modal.message-ok'));
                                setModalForm(false);
                                setPending(false);
                                setIsAlbumInfoPending(true);
                                onShowAlert('success', 'Ваши изменения успешно применены.');
                            })
                            .catch((err) => {
                                if(!axios.isCancel(err)) {
                                    setPending(false);
                                    if (err.response.status === 404) {
                                        onShowAlert('warning', `${Object.values(err.response.data)[0]}`, true);
                                    } else if (Object.values(err.response.data)[0]) {
                                        onShowAlert('warning', `${Object.values(err.response.data)[0]}`);
                                    } else {
                                        onShowAlert('warning', 'Что-то пошло не так.');
                                    }
                                }
                            });
                    } else {
                        api.albums.partialUpdateAlbum(Number(id), updateData)
                            .then((resp) => {
                                setMessage(t('route.album.modal.message-ok'));
                                setModalForm(false);
                                setPending(false);
                                setIsAlbumInfoPending(true);
                                onShowAlert('success', 'Ваши изменения успешно применены.');
                            })
                            .catch((err) => {
                                if(!axios.isCancel(err)) {
                                    setPending(false);
                                    if (err.response.status === 404) {
                                        onShowAlert('warning', `${Object.values(err.response.data)[0]}`, true);
                                    } else if (Object.values(err.response.data)[0]) {
                                        onShowAlert('warning', `${Object.values(err.response.data)[0]}`);
                                    } else {
                                        onShowAlert('warning', 'Что-то пошло не так.');
                                    }
                                }
                            });
                    }
                }
            }
        }
    }, [modalForm, parentAlbum]);

    const onClickModal = useCallback(() => {
        setModalForm(true);
    }, [modalForm, modalMessage]);

    const onClickCloseModal = (): void => {
        setModalForm(false);
        setModalAccess(false);
    };

    const onShowAlert = (type?: string, text?: string, isCustom?: boolean) => {
        if (type && text && !isCustom) {
            setShowWarningModal(null);
            show(text, type);
        }
        if (isCustom) {
            hide();
            setShowWarningModal({type, text, show: true});
        }

    };

    const onClickMoreAlbums = (e: React.MouseEvent): void => {
        e.preventDefault();

        if (isAlbumListNext) {
            setAlbumListPage((prev) => prev + 1);
            setIsAlbumListLoadMore(true);
        }
    };

    const elAlbumContent = useMemo(() => {
        if (isAlbumListPending) {
            return <Loader />;
        }

        if(albumList.length) {
            return (
                <Fragment>
                    <UI.PageHeader text="Вложенные альбомы" />
                    <div className={cn('album-sub__items')}>
                        {albumList.map((item, index) => {
                            return (
                                <AlbumCard
                                    album={item}
                                    key={index}
                                    name={item.name}
                                    id={item.id}
                                    isInvited={false}
                                    photos={item.photos}
                                    photos_count={albumListTotal}
                                    className={cn('invite__post')}
                                    isBlankLink={true}
                                    parent={Number(id)}
                                />
                            );
                        })}
                    </div>
                </Fragment>
            );
        }
    }, [JSON.stringify(albumList), isAlbumListPending]);

    const elButtonBeforeAlbums = () => {
        if(isAlbumListLoadMore) {
            return <Loader />;
        }

        if (!isAlbumListPending && !isAlbumListLoadMore && albumList?.length && isAlbumListNext) {
            if(!(albumList?.length - 1 === albumListTotal)) {
                return (
                    <Button
                        disabled={isAlbumListPending}
                        isLoading={isAlbumListPending || isAlbumListLoadMore}
                        isSecondary={true}
                        onClick={onClickMoreAlbums}
                    >
                        Загрузить ещё
                    </Button>
                );
            }
        }
    };

    const elModal = useMemo(() => {
        if (modalForm && albumInfo) {
            return (
                <AlbumModal
                    title={t('route.album.modal.title')}
                    album={albumInfo}
                    registry={registry}
                    onClickClose={onClickCloseModal}
                    onSubmitClick={() => onSubmit(false)}
                    pending={pending}
                />
            );
        }
    }, [error, modalForm]);

    const elModalAccess = useMemo(() => {
        if (modalAccess && albumInfo) {
            return (
                <AlbumAccess
                    albumId={albumInfo.id}
                    onClickClose={onClickCloseModal}
                />
            );
        }
    }, [modalAccess]);

    const onClickDelete = (): void => {
        if (photosWithFaceTotal || photosWithoutFaceTotal) {
            setMessage(t('route.album.message.del-error'));
            setModalMessage(true);
        } else if (queryParams.parent) {
            api.albums.destroyAlbumAlbums(queryParams.parent, Number(id))
                .then(() => {
                    history.push('/dashboard/photos');
                })
                .catch((err) => {
                    if(!axios.isCancel(err)) {
                        console.error(err);
                    }
                });
        } else {
            api.albums.destroyAlbum(Number(id))
                .then(() => {
                    history.push('/dashboard/photos');
                })
                .catch((err) => {
                    if(!axios.isCancel(err)) {
                        console.error(err);
                    }
                });
        }
    };

    const onClickAccess = (): void => {
        setModalAccess(true);
    };

    const onClickCreateInner = (): void => {
        setIsCreateInnerModal(true);
    };

    const onClickCloseCreateInnerModal = (): void => {
        setIsCreateInnerModal(false);
    };

    const elCreateInnerModal = useMemo(() => {
        if (isCreateInnerModal) {
            return (
                <AlbumModal
                    title={'Создать вложенный альбом'}
                    registry={registry}
                    onClickClose={onClickCloseCreateInnerModal}
                    onSubmitClick={() => onSubmit(true)}
                />
            );
        }
    }, [isCreateInnerModal]);

    const elButtonAccess = useMemo(() => {
        if (albumInfo && albumInfo.is_private) {
            return (
                <Button
                    isSecondary={true}
                    className={cn('album__sidebar_button')}
                    onClick={onClickAccess}
                >
                    <div className={cn('album__sidebar_button-text')}>
                        {t('route.album.button-album-access')}
                    </div>
                </Button>
            );
        }
    }, [albumInfo]);

    const elSidebarButton = useMemo(() => {
        return (
            <UI.Box padding={true} className={cn('album__sidebar_box')}>
                <Fragment>
                    <Button
                        to={albumInfo?.is_video ? `/upload-video?album_id=${id}` : `/upload-photo?album_id=${id}`}
                        className={cn('album__sidebar_button')}
                    >
                        <div className={cn('album__sidebar_button-icon')}>
                            <FontAwesomeIcon icon={faPlusSquare} />
                        </div>
                        <div className={cn('album__sidebar_button-text')}>
                            {albumInfo?.is_video ? `
                            ${t('global.button.video-upload')}
                            ` : `
                            ${t('global.button.photo-upload')}
                            `}
                        </div>
                    </Button>
                    <Button
                        isSecondary={true}
                        className={cn('album__sidebar_button')}
                        onClick={onClickModal}
                    >
                        <div className={cn('album__sidebar_button-icon')}>
                            <FontAwesomeIcon icon={faPenSquare} />
                        </div>
                        <div className={cn('album__sidebar_button-text')}>
                            {t('route.album.button-album-update')}
                        </div>
                    </Button>
                    <Button
                        isSecondary={true}
                        className={cn('album__sidebar_button')}
                        onClick={onClickDelete}
                    >
                        <div className={cn('album__sidebar_button-icon')}>
                            <FontAwesomeIcon icon={faWindowClose} />
                        </div>
                        <div className={cn('album__sidebar_button-text')}>
                            {t('route.album.button-album-delete')}
                        </div>
                    </Button>
                </Fragment>
                <Button
                    className={cn('album__sidebar_button')}
                    onClick={() => setPhotoSaleModal(true)}
                >
                    Скидки
                </Button>

                {!queryParams.parent && (
                    <Button
                        className={cn('album__sidebar_button')}
                        onClick={onClickCreateInner}
                    >
                        <div className={cn('album__sidebar_button-icon')}>
                            <FontAwesomeIcon icon={faBoxes} />
                        </div>
                        <div className={cn('album__sidebar_button-text')}>
                            {t('route.album.button-album-create')}
                        </div>
                    </Button>
                )}
                {elButtonAccess}
            </UI.Box>
        );
    }, [albumInfo]);

    const elSettingsBtn = useMemo(() => {
        if (isMobile || isTablet) {
            return (
                <ActionButton
                    className={cn('album__btn-setting')}
                >
                    <ButtonCircular
                        text={'Редактировать альбом'}
                        isSmall={true}
                        onClick={onClickModal}
                    >
                        <FontAwesomeIcon icon={faEdit} />
                    </ButtonCircular>
                    <ButtonCircular
                        text={'Удалить альбом'}
                        isSmall={true}
                        onClick={onClickDelete}
                    >
                        <FontAwesomeIcon icon={faTrashAlt} />
                    </ButtonCircular>
                    {albumInfo && albumInfo.is_private && (
                        <ButtonCircular
                            text={'Предоставить доступ'}
                            isSmall={true}
                            onClick={onClickDelete}
                        >
                            <FontAwesomeIcon icon={faUserPlus} />
                        </ButtonCircular>
                    )}
                </ActionButton>
            );
        }
    }, [albumInfo]);

    useEffect(() => {
        return () => {
            tokenWithFace.remove();
            tokenWithoutFace.remove();
            token.remove();
            tokenAlbum.remove();
            tokenEdit.remove();
            cancelToken.remove();
            tokenEditUser.remove();
            tokenUserSelfInfo.remove();
        };
    }, []);

    useEffect(() => {
        refIdsWithoutFaces.current = idsWithoutFaces;
        refIdsWithFaces.current = idsWithFaces;

        const photosWithFaces =  Object.keys(refIdsWithFaces.current).reduce((accum: Array<number>, current: string) => {
            return accum.concat(refIdsWithFaces.current[Number(current)]);
        }, []);
        const photosWithoutFaces =  Object.keys(refIdsWithoutFaces.current).reduce((accum: Array<number>, current: string) => {
            return accum.concat(refIdsWithoutFaces.current[Number(current)]);
        }, []);

        setIsModerationBtn(Boolean(photosWithoutFaces.length));
        setIdsList([...photosWithFaces, ...photosWithoutFaces]);
    }, [JSON.stringify(idsWithFaces), JSON.stringify(idsWithoutFaces)]);

    useEffect(() => {
        refReset.current = resetIdsList;
    }, [resetIdsList]);

    useEffect(() => {
        setIsAlbumInfoPending(true);
        setIsAlbumListPending(true);
    }, []);

    useEffect(() => {
        setPhotosWithFacePage(1);
        setIsPhotosWithFaceNext(true);
        setIsPhotosWithFaceLoading(true);

        setPhotosWithoutFacePage(1);
        setIsPhotosWithoutFaceNext(true);
        setIsPhotosWithoutFaceLoading(true);

        if (queryParams.parent) {
            setParentAlbum(Number(parent));
        }
    }, [JSON.stringify(queryParams)]);

    useEffect(() => {
        if (isPhotosWithFaceLoading || isPhotosWithFaceLoadMore) {
            const page: Page = {
                pageNumber: photosWithFacePage,
                pageSize: PHOTOS_LIMIT
            };

            const params: GetAlbumPhotoData = {
                is_faces_detected: true,
                ...(queryParams.number && { number_id: queryParams.number }),
                ...(queryParams.color_ids && { color_id: queryParams.color_ids }),
                ...(queryParams.time_from && { time_after: queryParams.time_from }),
                ...(queryParams.time_to && { time_before: queryParams.time_to }),
                ...(queryParams.person_name && { search: queryParams.person_name }),
                ...(queryParams.date_from && { date_after: queryParams.date_from }),
                ...(queryParams.date_end && { date_before: queryParams.date_end }),
                ...(queryParams.price_from && { price_min: queryParams.price_from }),
                ...(queryParams.price_to && { price_max: queryParams.price_to }),
                ...(queryParams.file_id && { file_id: queryParams.file_id })
            };

            api.albums.getAlbumPhotoList(Number(id), page, params)
                .then((resp) => {
                    const newPhotos = isPhotosWithFaceLoadMore ? [...photosWithFaceList, ...resp.data.results] : resp.data.results;
                    if (newPhotos.length) {
                        setPhotoWithFaceMap(newSortPhotosList(newPhotos));
                    } else {
                        setPhotoWithFaceMap(null);
                    }

                    setPhotosWithFaceList(newPhotos);
                    setPhotosWithFaceTotal(resp.data.count);
                    setIsPhotosWithFaceLoadMore(false);
                    setIsPhotosWithFaceLoading(false);
                })
                .catch(() => {
                    setIsPhotosWithFaceLoadMore(false);
                    setIsPhotosWithFaceLoading(false);
                });
        }
    }, [isPhotosWithFaceLoading, isPhotosWithFaceLoadMore]);

    useEffect(() => {
        if (isPhotosWithoutFaceLoading || isPhotosWithoutFaceLoadMore) {
            const page: Page = {
                pageNumber: photosWithoutFacePage,
                pageSize: PHOTOS_LIMIT
            };

            const params: GetAlbumPhotoData = {
                is_faces_detected: false,
                ...(queryParams.number && { number_id: queryParams.number }),
                ...(queryParams.color_ids && { color_id: queryParams.color_ids }),
                ...(queryParams.time_from && { time_after: queryParams.time_from }),
                ...(queryParams.time_to && { time_before: queryParams.time_to }),
                ...(queryParams.person_name && { search: queryParams.person_name }),
                ...(queryParams.date_from && { date_after: queryParams.date_from }),
                ...(queryParams.date_end && { date_before: queryParams.date_end }),
                ...(queryParams.price_from && { price_min: queryParams.price_from }),
                ...(queryParams.price_to && { price_max: queryParams.price_to }),
                ...(queryParams.file_id && { file_id: queryParams.file_id })
            };

            api.albums.getAlbumPhotoList(Number(id), page, params)
                .then((resp) => {
                    const newPhotos = isPhotosWithoutFaceLoadMore ? [...photosWithoutFaceList, ...resp.data.results] : resp.data.results;
                    if (newPhotos.length) {
                        setPhotoWithoutFaceMap(newSortPhotosList(newPhotos));
                    } else {
                        setPhotoWithoutFaceMap(null);
                    }

                    setPhotosWithoutFaceList(newPhotos);
                    setPhotosWithoutFaceTotal(resp.data.count);
                    setIsPhotosWithoutFaceLoadMore(false);
                    setIsPhotosWithoutFaceLoading(false);
                })
                .catch(() => {
                    setIsPhotosWithoutFaceLoadMore(false);
                    setIsPhotosWithoutFaceLoading(false);
                });
        }
    }, [isPhotosWithoutFaceLoading, isPhotosWithoutFaceLoadMore]);

    const onResetForm = useCallback(() => {
        registry.form.clearForm();
        onSubmitFilterForm();
    }, []);

    const onFileLoaded = () => {
        onSubmitFilterForm();
    };

    const onSubmitFilterForm = debounce(useCallback(() => {
        const formParams = getFormParams(form.getPayload());

        const data = {
            ...(queryParams.parent && { parent: queryParams.parent }),
            ...(formParams.number && { number: formParams.number }),
            ...(formParams.color_ids && { color_ids: formParams.color_ids }),
            ...(formParams.time_from && { time_from: formParams.time_from }),
            ...(formParams.time_to && { time_to: formParams.time_to }),
            ...(formParams.person_name && { person_name: formParams.person_name }),
            ...(formParams.date_from && { date_from: formParams.date_from }),
            ...(formParams.date_end && { date_end: formParams.date_end }),
            ...(formParams.price_from && { price_from: formParams.price_from }),
            ...(formParams.price_to && { price_to: formParams.price_to }),
            ...(formParams.file_id && { file_id: formParams.file_id })
        };

        history.replace({
            search: stringify(data, {
                arrayFormat: 'none'
            }),
            state: {
                noScroll: true
            }
        });
    }, []), 300);

    const _moderationPhotos = () => {
        const photosWithoutFaces =  Object.keys(idsWithoutFaces).reduce((accum: Array<number>, current: string) => {
            return accum.concat(idsWithoutFaces[Number(current)]);
        }, []);

        if (Boolean(photosWithoutFaces.length)) {
            api.photos.createModerationRequest(photosWithoutFaces)
                .then(() => {
                    onShowAlert('success', 'Выбранные фотографии отправлены на модерацию.');
                    setPhotosWithoutFacePage(1);
                    setIsPhotosWithoutFaceNext(true);
                    setIsPhotosWithoutFaceLoading(true);
                    setIdsWithoutFaces([]);
                })
                .catch((err) => {
                    if (Object.values(err.response.data)[0]) {
                        onShowAlert('warning', `${Object.values(err.response.data)[0]}`);
                    } else {
                        onShowAlert('warning', 'Не удалось отправить заявку на модерацию.');
                    }
                });
        }
    };

    const onClickModerationPhotos = useCallback(() => {
        _moderationPhotos();
    }, [idsWithoutFaces]);

    const onChangeSelectedWithFaces = useCallback((index: number) => (ids: Array<number>) => {
        const newList = { ...refIdsWithFaces.current };
        newList[index] = ids;

        setIdsWithFaces(newList);
    }, []);

    const onChangeSelectedWithoutFaces = useCallback((index: number) => (ids: Array<number>) => {
        const newList = { ...refIdsWithoutFaces.current };
        newList[index] = ids;

        setIdsWithoutFaces(newList);
    }, []);

    const getFormParams = (data: IPayload) => {
        const faces = data.photo?.tmp_faces;
        let personsNew: Array<DataFilesTmpFacesPersonsItem> = [];

        if(faces?.length) {
            personsNew = faces.reduce((acc: Array<DataFilesTmpFacesPersonsItem>, curr: DataFilesTmpFacesItem) => {
                if(curr.persons?.length) {
                    curr.persons.forEach((person) => {
                        const isExist = acc.find((item) => item.id === person.id);

                        if(person.id && !isExist) {
                            acc.push(person);
                        }
                    });
                }

                return acc;
            }, []);
        }

        return {
            ...(personsNew.length && { person_ids: personsNew.map((item) => item.id) }),
            ...(data.name && { person_name: data.name }),
            ...(data.location?.value && { location_id: data.location?.value }),
            ...(data.event?.value && { event_id: data.event.value }),
            ...(data.price_range?.value_from && { price_from: data.price_range?.value_from }),
            ...(data.price_range?.value_to && { price_to: data.price_range?.value_to }),
            ...(data.event_date_range?.date_from && { date_from: data.event_date_range?.date_from }),
            ...(data.event_date_range?.date_to && { date_end: data.event_date_range?.date_to }),
            ...(data.clubs?.length && { club_ids: data.clubs.map((club: IValue) => club.value) }),
            ...(data.color && { color_ids: data.color }),
            ...(data.sport_number && { number: data.sport_number }),
            ...(data.time && { time: data.time }),
            ...(data.timeRange?.valueFrom && { time_from: data.timeRange.valueFrom }),
            ...(data.timeRange?.valueTo && { time_to: data.timeRange.valueTo }),
            ...(data.photo && { file_id: data.photo.id })
        };
    };

    const elPhotosWithFaces = useMemo(() => {
        if (isPhotosWithFaceLoading) {
            return <Loader />;
        }

        if (photoWithFaceMap) {
            const keys = Object.keys(photoWithFaceMap);

            return keys.map((key, index) => {
                return (
                    <div key={index}>
                        <NewPhotoList
                            elControls={true}
                            dateLink={true}
                            list={photoWithFaceMap[key]}
                            onChangeSelectedList={onChangeSelectedWithFaces(index)}
                            resetSelected={resetIdsList}
                            is_prepaid={albumInfo?.is_prepaid || false}
                        />
                    </div>
                );
            });
        }

        return <div className={cn('album__empty')}>Фото не найдены</div>;
    }, [JSON.stringify(photoWithFaceMap), resetIdsList, isPhotosWithFaceLoading]);

    const elPhotosWithoutFaces = useMemo(() => {
        if (isPhotosWithoutFaceLoading) {
            return <Loader />;
        }

        if (photoWithoutFaceMap) {
            const keys = Object.keys(photoWithoutFaceMap);

            return keys.map((key, index) => {
                return (
                    <div key={index}>
                        <NewPhotoList
                            elControls={true}
                            dateLink={true}
                            list={photoWithoutFaceMap[key]}
                            onChangeSelectedList={onChangeSelectedWithoutFaces(index)}
                            resetSelected={resetIdsList}
                            is_prepaid={albumInfo?.is_prepaid || false}
                        />
                    </div>
                );
            });
        }

        return <div className={cn('album__empty')}>Фото не найдены</div>;
    }, [JSON.stringify(photoWithoutFaceMap), resetIdsList, isPhotosWithoutFaceLoading]);

    const onClickMorePhotoWithFace = (): void => {
        if (isPhotosWithFaceNext) {
            setPhotosWithFacePage((prev) => prev + 1);
            setIsPhotosWithFaceLoadMore(true);
        }
    };

    const elMorePhotoWithFace = () => {
        if(!isPhotosWithFaceLoading && photosWithFaceList?.length) {
            if (!(photosWithFaceList?.length === photosWithFaceTotal)) {
                return (
                    <div className={cn('photos__btn-more')}>
                        <Button
                            disabled={isPhotosWithFaceLoadMore}
                            isLoading={isPhotosWithFaceLoadMore}
                            isSecondary={true}
                            onClick={onClickMorePhotoWithFace}
                        >
                            Загрузить ещё
                        </Button>
                    </div>
                );
            }
        }
    };

    const onClickMorePhotoWithoutFace = (): void => {
        if (isPhotosWithoutFaceNext) {
            setPhotosWithoutFacePage((prev) => prev + 1);
            setIsPhotosWithoutFaceLoadMore(true);
        }
    };

    const onClickHideWarningModal = () => {
        setShowWarningModal(null);
    };

    const elWarningModal = useMemo(() => {
        if (showWarningModal) {
            return (
                <CustomAlert type={showWarningModal.type} text={showWarningModal.text} onClick={onClickHideWarningModal} />
            );
        }
    }, [showWarningModal]);

    const elBreadcrumbs = useMemo(() => {
        if (albumInfo && !isAlbumInfoPending && !isLoadingParentInfo) {
            if (parentInfo) {
                const breadcrumbItems = [
                    { label: 'Альбомы', to: '/dashboard/photos' },
                    { label: parentInfo.name, to: `/albums/${parentInfo.id}` },
                    { label: albumInfo.name }
                ];

                return <Breadcrumbs items={breadcrumbItems} />;
            } else {
                const breadcrumbItems = [
                    { label: 'Альбомы', to: '/dashboard/photos' },
                    { label: albumInfo.name }
                ];

                return <Breadcrumbs items={breadcrumbItems} />;
            }
        }
    }, [albumInfo, parentInfo, isAlbumInfoPending, isLoadingParentInfo]);

    const elMorePhotoWithoutFace = () => {
        if(!isPhotosWithoutFaceLoading && photosWithoutFaceList?.length) {
            if (!(photosWithoutFaceList?.length === photosWithoutFaceTotal)) {
                return (
                    <div className={cn('photos__btn-more')}>
                        <Button
                            disabled={isPhotosWithoutFaceLoadMore}
                            isLoading={isPhotosWithoutFaceLoadMore}
                            isSecondary={true}
                            onClick={onClickMorePhotoWithoutFace}
                        >
                            Загрузить ещё
                        </Button>
                    </div>
                );
            }
        }
    };

    const elPhotoSaleModal = useMemo(() => {
        if (photoSaleModal) {
            return (
                <PhotoSaleModal
                    albumId={Number(id)}
                    registry={registry}
                    onClickClose={() => setPhotoSaleModal(false)}
                />
            );
        }
    }, [photoSaleModal]);

    return (
        <>
            {elBreadcrumbs}
            <SideAction
                title={albumInfo?.name ? albumInfo.name : ''}
                description={albumInfo?.description ? albumInfo.description : ''}
                content={(
                    <div>
                        <div className={cn('album-sub')}>
                            {elAlbumContent}
                            {elButtonBeforeAlbums()}
                        </div>
                        {elSettingsBtn}
                        <section className={cn('album__top')}>
                            <UI.BoxHeader className={cn('album__top-header')}>
                                Фотографии без лиц (требуют модерации) {photosWithoutFaceTotal !== 0 && <span>{photosWithoutFaceTotal} фото</span>}
                            </UI.BoxHeader>
                            <UI.Main className={cn('album__top-content')}>
                                <UI.Box padding={true} className={cn('album__content-box')}>
                                    {isModerationBtn && (
                                        <div className={cn('album__moderation-btn')}>
                                            <Button onClick={onClickModerationPhotos}>Отправить на модерацию</Button>
                                        </div>
                                    )}
                                    {elPhotosWithoutFaces}
                                    {elMorePhotoWithoutFace()}
                                </UI.Box>
                            </UI.Main>
                        </section>
                        <section className={cn('album__top')}>
                            <UI.BoxHeader className={cn('album__top-header')}>
                                Фотографии для продажи {photosWithFaceTotal !== 0 && <span>{photosWithFaceTotal} фото</span>}
                            </UI.BoxHeader>
                            <UI.Main className={cn('album__top-content')}>
                                <UI.Box padding={true} className={cn('album__content-box')}>
                                    {elPhotosWithFaces}
                                    {elMorePhotoWithFace()}
                                </UI.Box>
                            </UI.Main>
                        </section>
                    </div>
                )}
                sidebar={elSidebarButton}
                idsList={idsList}
                form={form}
                field={field}
                isSearchPerson={true}
                color={true}
                personNumber={true}
                update={updPhotoInfo}
                delete={deletePhotoInfo}
                isPrice={true}
                isName={true}
                isTimeRange={true}
                onSubmitForm={onSubmitFilterForm}
                onReset={onResetForm}
                onFileLoaded={onFileLoaded}
            >
                {elWarningModal}
                {elModal}
                {elModalAccess}
                {elPhotoSaleModal}
                {elCreateInnerModal}
            </SideAction>
        </>
    );
};

// tslint:disable-next-line:max-file-line-count
export default Album;
